import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { AdminGate } from "../events/AdminGate";
import { PrepTab } from "./PrepTab";
import { ShoppingTab } from "./ShoppingTab";
import { RecipesTab } from "./RecipesTab";
import { IngredientsTab } from "./IngredientsTab";
import { VendorInvoicesTab } from "./VendorInvoicesTab";
import { PriceAlerts } from "./PriceAlerts";

const TABS = [["prep", "Prep sheets"], ["shopping", "Shopping list"], ["recipes", "Recipes"], ["ingredients", "Ingredients"], ["invoices", "Vendor invoices"]];

function Kitchen() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "prep";
  const [units, setUnits] = useState(null);
  const [alertsKey, setAlertsKey] = useState(0);
  useEffect(() => { api.get("/admin/kitchen/units").then((r) => setUnits(r.data)); }, []);
  return (
    <div className="min-h-screen bg-brand-cream/50" data-testid="kitchen-page">
      <div className="max-w-4xl mx-auto px-4 pt-5 pb-16">
        <Link to="/admin/orders" data-testid="kitchen-back" className="inline-flex items-center gap-1.5 text-[12px] font-bold uppercase tracking-[0.1em] text-brand-charcoal/60 print:hidden">
          <ArrowLeft className="h-3.5 w-3.5" /> Admin
        </Link>
        <h1 className="mt-3 font-display font-black text-4xl text-brand-charcoal print:text-2xl">Kitchen</h1>
        <p className="mt-1 text-[14px] text-brand-charcoal/60 print:hidden">Recipes drive the prep sheets and the shopping list automatically.</p>
        <div className="mt-5 flex gap-1.5 overflow-x-auto print:hidden" role="tablist">
          {TABS.map(([k, label]) => (
            <button key={k} type="button" role="tab" aria-selected={tab === k} onClick={() => setParams({ tab: k })} data-testid={`kitchen-tab-${k}`}
              className={`shrink-0 h-10 px-4 rounded-full text-[11.5px] font-bold uppercase tracking-[0.1em] ${tab === k ? "bg-brand-charcoal text-white" : "bg-white border border-black/10 text-brand-charcoal/70"}`}>
              {label}
            </button>
          ))}
        </div>
        <PriceAlerts refreshKey={alertsKey} />
        <div className="mt-5">
          {!units ? <Loader2 className="h-5 w-5 animate-spin text-brand-teal" /> : (
            <>
              {tab === "prep" && <PrepTab />}
              {tab === "shopping" && <ShoppingTab />}
              {tab === "recipes" && <RecipesTab units={units} />}
              {tab === "ingredients" && <IngredientsTab units={units} />}
              {tab === "invoices" && <VendorInvoicesTab onApplied={() => setAlertsKey((k) => k + 1)} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default function KitchenPage() {
  return <AdminGate><Kitchen /></AdminGate>;
}
